import React from 'react';
import { Button, Grid, styled, useBpDesignTheme } from '@beeline.com/bp-design-system';
import { ModalFooter } from './ModalFooter';
import { useUserEvent, UserEvents } from '../integrations/userEvents/useUserEvent';

type ContinueButtonProps = {
  onContinue: (val: any) => void;
  onBack?: () => void;
  title: string;
  backTitle?: string;
  isLoading?: boolean;
  disabled?: boolean;
  trackStepName: string;
};

export const ContinueButton = ({
  onContinue,
  onBack,
  title,
  backTitle,
  isLoading,
  disabled,
  trackStepName
}: ContinueButtonProps) => {
  const nextButtonMobileWidth = onBack ? '8rem' : '100%';
  const theme = useBpDesignTheme();
  const { track } = useUserEvent();

  return (
    <ModalFooter>
      <Grid container justifyContent="center">
        {onBack && (
          <BackButton
            onClick={() => {
              track(UserEvents.importerEvents.BACK, { trackStepName });
              onBack();
            }}
            disabled={isLoading || disabled}
          >
            {backTitle}
          </BackButton>
        )}
        <StyledButton
          dataTest="next-button"
          size="large"
          color="primary"
          variant="contained"
          disabled={disabled}
          sx={{
            [theme.breakpoints.down('md')]: {
              width: nextButtonMobileWidth
            },
            [theme.breakpoints.up('md')]: {
              width: '21rem'
            }
          }}
          onClick={() => {
            track(UserEvents.importerEvents.NEXT, { trackStepName });
            onContinue(title);
          }}
          loading={isLoading}
        >
          {title}
        </StyledButton>
      </Grid>
    </ModalFooter>
  );
};

const BackButton = styled(Button)`
  && {
    margin-right: auto;
  }
`;

const StyledButton = styled(Button)`
  && {
    margin-right: auto;
    white-space: nowrap;
  }
`;
